import muslinTwoBibsTwoP from "./muslinTwo_rg/img_muslinTwoBibsTwo_rg_p.jpg";
import muslinTwoBibsTwo from "./muslinTwo_rg/img_muslinTwoBibsTwo_rg.jpg";

import muslinTwo from "./muslinTwo_rg/img_muslinTwo_rg.jpg";
import muslinTwoP from "./muslinTwo_rg/img_muslinTwo_rg_p.jpg";

import muslinTwoBibsTwoEars from "./muslinTwo_rg/img_muslinTwoBibsTwoEars_rg.jpg";
import muslinTwoBibsTwoEarsP from "./muslinTwo_rg/img_muslinTwoBibsTwoEars_rg_p.jpg";

import muslinTwoBunny from "./muslinTwo_rg/img_muslinTwoBunny_rg.jpg";
import muslinTwoBunnyP from "./muslinTwo_rg/img_muslinTwoBunny_rg_p.jpg";

import muslinTwoBunnyEars from "./muslinTwo_rg/img_muslinTwoBunnyEars_rg.jpg";
import muslinTwoBunnyEarsP from "./muslinTwo_rg/img_muslinTwoBunnyEars_rg_p.jpg";

import muslinTwoBunnyEarsBib from "./muslinTwo_rg/img_muslinTwoBunnyEarsBib_rg.jpg";
import muslinTwoBunnyEarsBibP from "./muslinTwo_rg/img_muslinTwoBunnyEarsBib_rg_p.jpg";

import muslinTwoEars from "./muslinTwo_rg/img_muslinTwoEars_rg.jpg";
import muslinTwoEarsP from "./muslinTwo_rg/img_muslinTwoEars_rg_p.jpg";

import muslinTwoEarsBib from "./muslinTwo_rg/img_muslinTwoEarsBib_rg.jpg";
import muslinTwoEarsBibP from "./muslinTwo_rg/img_muslinTwoEarsBib_rg_p.jpg";

export default [
    {
        type: "muslinTwo",
        noPostcard: muslinTwo,
        withPostcard: muslinTwoP,
    },
    {
        type: "muslinTwoBibsTwo",
        noPostcard: muslinTwoBibsTwo,
        withPostcard: muslinTwoBibsTwoP,
    },
    {
        type: "muslinTwoBibsTwoEars",
        noPostcard: muslinTwoBibsTwoEars,
        withPostcard: muslinTwoBibsTwoEarsP,
    },
    {
        type: "muslinTwoBunny",
        noPostcard: muslinTwoBunny,
        withPostcard: muslinTwoBunnyP,
    },
    {
        type: "muslinTwoBunnyEars",
        noPostcard: muslinTwoBunnyEars,
        withPostcard: muslinTwoBunnyEarsP,
    },
    {
        type: "muslinTwoBunnyEarsBib",
        noPostcard: muslinTwoBunnyEarsBib,
        withPostcard: muslinTwoBunnyEarsBibP,
    },
    {
        type: "muslinTwoEars",
        noPostcard: muslinTwoEars,
        withPostcard: muslinTwoEarsP,
    },
    {
        type: "muslinTwoEarsBib",
        noPostcard: muslinTwoEarsBib,
        withPostcard: muslinTwoEarsBibP,
    }
]